/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreEntitiesRiotRegionSchema = z.enum([
  "BR1",
  "EUN1",
  "EUW1",
  "LA1",
  "LA2",
  "NA1",
  "OC1",
  "RU",
  "TR1",
  "ME1",
  "JP1",
  "KR",
  "SEA",
  "SG2",
  "TW2",
  "VN2",
  "PBE",
]);
